import type { ChipProps } from '@material-ui/core/Chip';
import Chip from '@material-ui/core/Chip';
import type { GridSpacing } from '@material-ui/core/Grid';
import Grid from '@material-ui/core/Grid';
import MyIcon from 'components/Icon';
import React from 'react';

import type { ISubscriptions } from 'v2/interfaces/subscriptions';

import useStyles from './styles';

type ChipPropsExtends = 'size' | 'variant';

interface IProps extends Pick<ChipProps, ChipPropsExtends> {
  subscription: ISubscriptions;
  spacing?: GridSpacing;
}

const SubscriptionTags = ({ size = 'medium', variant = 'outlined', subscription, spacing = 2 }: IProps) => {
  const styleProps = { size };
  const classes = useStyles(styleProps);

  if (!subscription.currency || subscription.currency === 'BRL') return null;

  const chipDefaultProps = {
    size,
    variant,
    classes: {
      root: classes.chipRoot,
      label: classes.chipLabel,
      deleteIcon: classes.chipDeleteIcon,
    },
    onDelete: () => ({}),
  };

  return (
    <Grid container spacing={spacing}>
      <Grid item>
        <Chip {...chipDefaultProps} label='Venda Internacional' deleteIcon={<MyIcon className='icon' name='globe' />} />
      </Grid>
    </Grid>
  );
};

export default SubscriptionTags;
